import { Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { HOTEL_EDIT, HOTEL_VIEW_TAB_LIST } from '../../../../constants/PropertyConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTELS,
} from '../../../../constants/RoleConsts';
import CustomDocumentViewer from '../../../../shared/custom-document-viewer/Custom-Document-Viewer';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import CustomPhoneNoView from '../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import LocationMap from '../../../../shared/google-map/LocationMap';
import RedirectUrlLink from '../../../../shared/redirect-url-link/Redirect-Url-Link';
import { FormattingUtils } from '../../../../utils/DataFormattingUtils';
import { allBrandsSelector, allGroupsSelector, allHotelsSelector } from '../../propertySlice';
import { ASSET_URL } from '../../../../env/Configurations';
import './Hotel-View.scss';
import { decodeMediaKeyValue } from '../../../../utils/mediaUtils';

const HotelView = (props) => {
  const { hotel, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedHotel, setSelectedHotel] = useState();
  const [tabValue, setTabValue] = useState(0);
  const originalHotels = useSelector(allHotelsSelector);
  const groups = useSelector(allGroupsSelector);
  const brands = useSelector(allBrandsSelector);

  useEffect(() => {
    const hotelObj = {
      ...originalHotels.find((tempHotel) => tempHotel.id === hotel.id),
    };
    const brandName = FormattingUtils.getBrandName(brands, hotel.brandId);
    const groupName = FormattingUtils.getGroupName(groups, hotel.groupId);
    hotelObj['brandName'] = brandName;
    hotelObj['groupName'] = groupName;
    setSelectedHotel(hotelObj);
  }, [originalHotels]);

  const onClickEdit = (event) => {
    toggleDrawer(HOTEL_EDIT, true, selectedHotel);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Hotel</div>
                <div className='details-value'>{selectedHotel.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Hotel code</div>
                <div className='details-value'>{selectedHotel.code}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Hotel Brand</div>
                <div className='details-value'>{selectedHotel.brandName}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Hotel Group</div>
                <div className='details-value'>{selectedHotel.groupName}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{selectedHotel.description}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Check-In Time</div>
                <div className='details-value'>{selectedHotel.checkInTime}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Check-Out Time</div>
                <div className='details-value'>{selectedHotel.checkOutTime}</div>
              </div>
            </div>

            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Currency</div>
                <div className='details-value'>{selectedHotel.currency}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Phone Number</div>
                <div className='details-value'>
                  {selectedHotel?.phoneNumber ? (
                    <CustomPhoneNoView value={selectedHotel?.phoneNumber} />
                  ) : (
                    '---'
                  )}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Travel Type</div>
                <div className='details-value'>{selectedHotel.travelType?.join(', ') || '---'}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Interests</div>
                <div className='details-value'>{selectedHotel.interests?.join(', ') || '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Star Rating</div>
                <div className='details-value'>
                  {selectedHotel.starRating ? `${selectedHotel.starRating} Stars` : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedHotel.detailsCustomAttributes &&
                selectedHotel.detailsCustomAttributes.length > 0 &&
                selectedHotel.detailsCustomAttributes.map((item, index) => (
                  <div key={index} className='col-md-6'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Address Line 1</div>
                <div className='details-value'>{selectedHotel.location.addressLine1}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Address Line 2</div>
                <div className='details-value'>
                  {selectedHotel.location.addressLine2
                    ? selectedHotel.location.addressLine2
                    : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Country</div>
                <div className='details-value'>{selectedHotel.location.country}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>State</div>
                <div className='details-value'>{selectedHotel.location.state}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Postal Code</div>
                <div className='details-value'>
                  {selectedHotel.location.postalCode ? selectedHotel.location.postalCode : '---'}
                </div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>City</div>
                <div className='details-value'>{selectedHotel.location.city}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Latitude</div>
                <div className='details-value'>{selectedHotel?.location?.latitude || '---'}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Longitude</div>
                <div className='details-value'>{selectedHotel?.location?.longitude || '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Time Zone</div>
                <div className='details-value'>{selectedHotel.location.timezone}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-7'>
                <div className='details-label'>Google Maps</div>
                <div className='details-value'>
                  <LocationMap
                    lat={selectedHotel.location.latitude}
                    lng={selectedHotel.location.longitude}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {tabValue === 2 && (
          <>
            {!selectedHotel.covid19Regulations.url &&
              !selectedHotel.termsAndConditions.url &&
              !selectedHotel.cancellationPolicy.url &&
              !selectedHotel.dataProtection.url &&
              !selectedHotel.privacyLaws.url && (
                <div className='row mx-4 mt-4'>
                  <div className='col-md-12'>No data Available</div>
                </div>
              )}
            <div className='row pt-5 px-4'>
              {selectedHotel.covid19Regulations?.url && selectedHotel.covid19Regulations?.type && (
                <div className='col-md-3'>
                  <CustomDocumentViewer
                    document={selectedHotel.covid19Regulations}
                    title={
                      selectedHotel.covid19Regulations.type === 'S3'
                        ? selectedHotel.covid19Regulations.name
                          ? selectedHotel.covid19Regulations.name
                          : 'COVID-19 Rules & Instructions.pdf'
                        : 'COVID-19 Rules & Instructions url'
                    }
                  ></CustomDocumentViewer>
                </div>
              )}
              {selectedHotel?.termsAndConditions?.url &&
                selectedHotel?.termsAndConditions?.type && (
                  <div className='col-md-3'>
                    <CustomDocumentViewer
                      document={selectedHotel.termsAndConditions}
                      title={
                        selectedHotel.termsAndConditions.type === 'S3'
                          ? selectedHotel.termsAndConditions.name
                            ? selectedHotel.termsAndConditions.name
                            : 'Terms & Conditions.pdf'
                          : 'Terms & Conditions url'
                      }
                    ></CustomDocumentViewer>
                  </div>
                )}
              {selectedHotel?.cancellationPolicy?.url &&
                selectedHotel?.cancellationPolicy?.type && (
                  <div className='col-md-3'>
                    <CustomDocumentViewer
                      document={selectedHotel.cancellationPolicy}
                      title={
                        selectedHotel.cancellationPolicy.type === 'S3'
                          ? selectedHotel.cancellationPolicy.name
                            ? selectedHotel.cancellationPolicy.name
                            : 'Cancellation Policy.pdf'
                          : 'Cancellation Policy url'
                      }
                    ></CustomDocumentViewer>
                  </div>
                )}
              {selectedHotel?.dataProtection?.url && selectedHotel?.dataProtection?.type && (
                <div className='col-md-3'>
                  <CustomDocumentViewer
                    document={selectedHotel.dataProtection}
                    title={
                      selectedHotel.dataProtection.type === 'S3'
                        ? selectedHotel.dataProtection.name
                          ? selectedHotel.dataProtection.name
                          : 'Data Protection.pdf'
                        : 'Data Protection url'
                    }
                  ></CustomDocumentViewer>
                </div>
              )}
              {selectedHotel?.privacyLaws?.url && selectedHotel?.privacyLaws?.type && (
                <div className='col-md-3'>
                  <CustomDocumentViewer
                    document={selectedHotel.privacyLaws}
                    title={
                      selectedHotel.privacyLaws.type === 'S3'
                        ? selectedHotel.privacyLaws.name
                          ? selectedHotel.privacyLaws.name
                          : 'Privacy Laws.pdf'
                        : 'Privacy Laws url'
                    }
                  ></CustomDocumentViewer>
                </div>
              )}
            </div>
          </>
        )}
        {tabValue === 3 && (
          <>
            <div className='row mx-4 mt-4'>
              {selectedHotel.information?.map((item) => (
                <div className='col-md-12 mt-3'>
                  <div className='details-label'>
                    {item.field} - {item.displayTitle}
                  </div>
                  <div className='details-value'>
                    {item.type === 'PHONE' ? (
                      <CustomPhoneNoView value={item.value} />
                    ) : item.type === 'EMAIL' ? (
                      item.value
                    ) : (
                      <RedirectUrlLink url={item.value} />
                    )}
                  </div>
                </div>
              ))}
              {(!selectedHotel.information || selectedHotel.information.length === 0) &&
                (!selectedHotel.informationCustomAttributes ||
                  selectedHotel.informationCustomAttributes.length === 0) && (
                  <div className='col-md-12'>No data Available</div>
                )}
            </div>

            <div className='row mx-4 mt-4'>
              {selectedHotel.informationCustomAttributes &&
                selectedHotel.informationCustomAttributes.length > 0 &&
                selectedHotel.informationCustomAttributes.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}

        {tabValue === 4 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-8'>
                <div className='details-label'>Highlight Features</div>
                <div className='details-value mt-3'>
                  {selectedHotel.features?.length
                    ? selectedHotel.features.map((feature, i) => (
                        <Chip key={i} label={feature} className='me-3 mb-2' variant='outlined' />
                      ))
                    : '---'}
                </div>
              </div>
            </div>
          </>
        )}
        {tabValue === 5 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Welcome Message</div>
              </div>
            </div>
            {!selectedHotel?.wcMessage?.isWCMessageEnabled && (
              <div className='row mx-4 mt-4'>
                <div className='col-md-12'>No data Available</div>
              </div>
            )}
            {selectedHotel?.wcMessage?.isWCMessageEnabled && (
              <>
                <div className='row mx-4 mt-4'>
                  <div className='details-label'>Message Text</div>
                  <div className='details-value preview-breaks'>
                    {selectedHotel?.wcMessage?.messageText}
                  </div>
                </div>
                <div className='row mx-4 mt-4'>
                  {selectedHotel?.wcMessage?.signature?.isSignatureEnabled &&
                    selectedHotel?.wcMessage?.signature?.images && (
                      <div className='col-md-4'>
                        <div className='details-label'>Signature</div>
                        <div className='m-2 w-25 custom-image-view-image'>
                          <img
                            src={ASSET_URL + selectedHotel?.wcMessage?.signature?.images || ''}
                            alt='img'
                            className='custom-image-view-image-card cursor-pointer'
                            onClick={() => {}}
                          ></img>
                        </div>
                      </div>
                    )}
                  {selectedHotel?.wcMessage?.isImagesEnabled &&
                    selectedHotel?.wcMessage?.images[0]?.ratio1to1 && (
                      <div className='col-md-4'>
                        <div className='details-label'>Image</div>
                        <div className='m-2 w-50 custom-image-view-image'>
                          <img
                            src={ASSET_URL + selectedHotel?.wcMessage?.images[0]?.ratio16to9 || ''}
                            alt='img'
                            className='custom-image-view-image-card cursor-pointer'
                            onClick={() => {}}
                          ></img>
                        </div>
                      </div>
                    )}

                  {selectedHotel?.wcMessage?.video && (
                    <div className='col-md-4'>
                      <div className='details-label'>Video</div>
                      <div className='m-2 w-25 '>
                        <div className='custom-image-view-big-video'>
                          <img
                            className='mt-4 ms-4 video-icon'
                            src={'./assets/icons/dashboard/video-attach.svg'}
                            alt={'completed'}
                            onClick={() => window.open(selectedHotel?.wcMessage?.video, '_blank')}
                          />
                          <div
                            className='url-text'
                            onClick={() => window.open(selectedHotel?.wcMessage?.video, '_blank')}
                          >
                            {selectedHotel?.wcMessage?.video}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
        {tabValue === 6 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedHotel.images}
              videos={(() => {
                const { Video: videoMediaContent } = decodeMediaKeyValue(
                  selectedHotel?.mediaContent,
                );
                return videoMediaContent || selectedHotel.videos || {};
              })()}
              gifs={(() => {
                const { GIF: gifMediaContent } = decodeMediaKeyValue(selectedHotel?.mediaContent);
                return gifMediaContent || selectedHotel.gifs || {};
              })()}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedHotel && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={HOTEL_VIEW_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedHotel.name}
          createdUserId={selectedHotel.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTELS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};

export default HotelView;
